import { useMutation } from "react-query";
import http from "infra/http";
import { TransferenciaForm } from "../typings";
import { TransferenciaCreateResponse } from './../typings/index';

function useSaveTransferencia() {
  return useMutation(
    '/v1/transferencia',
    async (form: TransferenciaForm) => {
      const {data} = await http.post(`/v1/transferencia`, form);
      return data as TransferenciaCreateResponse;
    },
    { retry: false }
  );
}

export default useSaveTransferencia;
